// app/javascript/compcalc/components/Support.jsx

import React from 'react';
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import YouTube from 'react-youtube';


const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  wrapContent: {
    display: 'inline-block',
  },
  textField: {
    width: 100,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  textFieldAmount: {
    width: 150,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  alignCenter: {
    // background: 'green',
    textAlign: 'center',
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',    // Horizontal align.
    alignItems: 'center',        // Vertical align.
  },
  alignLeft: {
    // background: 'blue',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  alignRight: {
    // background: 'red',
    display: 'flex',
    flexFlow: 'row-reverse nowrap',
    alignItems: 'center',
  },
  paperStretch: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
  fixedWidth: {
    maxWidth: '800px',
    width: '100%',
  },
  pre: {
    width: '100%',
    maxWidth: '800px',
    whiteSpace: 'pre-wrap',
  }
});


class Support extends React.PureComponent {

  constructor(props) {
    super(props);

    this.videoIds = [ '0755Hqnlmpc', 'yVTm6RjlDRg', 'i_GyDo1O2WY' ];

    this.state = {
      currentVideo: 0,
    };
  }

  basics = () => {
    this.setState({ currentVideo: 0 });
  }

  rating = () => {
    this.setState({ currentVideo: 1 });
  }

  advanced = () => {
    this.setState({ currentVideo: 2 });
  }

  home = () => {
    window.open(global.config.isAIG ? 'https://www.aig.com/' : 
                global.config.isCAAA ? 'https://www.caaa.org/' : 
                global.config.isCompCalc ? 'https://www.montarbolaw.com/' : 
                'https://legal-records.us/');
  }

  contact = () => {
    if (global.config.isCompCalc) {
      window.open('https://www.montarbolaw.com/contact-us');
    }
    else {
      window.open('https://legal-records.us/contact-us');
    }
  }


  onReady = (event) => {
    // access to player in all event handlers via event.target
    // event.target.pauseVideo();
  }

  onEnd = (event) => {
    let currentVideo = currentVideo + 1;
    if (currentVideo < this.videoIds.length) {
      this.setState({ currentVideo: currentVideo });
    }
  }

  render() {
    const { classes } = this.props;

    const opts = {
      width: '640',
      height: '390',
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 0
      }
    };

    return (
      <Grid container spacing={1} className={classes.root} justifyContent="center">

        <Grid item xs={12} className={classes.alignCenter}>
          <YouTube
            videoId={ this.videoIds[this.state.currentVideo] }
            opts={ opts }
            onReady={ this.onReady }
            onEnd={ this.onEnd }
          />
        </Grid>

        <Grid item xs={4} className={classes.alignCenter}>
          <Button color="primary" variant="contained" size="medium" onClick={this.basics}>
            Basic Features & Functions
          </Button>
        </Grid>

        <Grid item xs={4} className={classes.alignCenter}>
          <Button color="primary" variant="contained" size="medium" onClick={this.rating}>
            Rating Tutorial
          </Button>
        </Grid>

        <Grid item xs={4} className={classes.alignCenter}>
          <Button color="primary" variant="contained" size="medium" onClick={this.advanced}>
            Advanced Tips & Techniques
          </Button>
        </Grid>

        <Grid item xs={2} />
        <Grid item xs={4} className={classes.alignCenter}>
          <Button color="primary" variant="contained" size="medium" onClick={this.home}>
            Our Web Page
          </Button>
        </Grid>

        <Grid item xs={4} className={classes.alignCenter}>
          <Button color="primary" variant="contained" size="medium" onClick={this.contact}>
            Contact Us
          </Button>
        </Grid>
        <Grid item xs={2} />

      </Grid>
    );
  }

};

export default withStyles(styles)(Support);
